import { render } from "./AgentManager.vue?vue&type=template&id=f156caaa"
import script from "./AgentManager.vue?vue&type=script&lang=js"
export * from "./AgentManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__